<div class="chat-thread">
  <ngx-simplebar #bar class="chat-thread__scroll">
    <div #fallback class="chat-thread__inner" role="log" aria-live="polite" aria-relevant="additions">

      <!-- skeleton: só enquanto o histórico não chegou -->
      <div *ngIf="loading && items.length === 0" class="chat-thread__skeleton" role="status" [attr.aria-label]="strings.loading">
        <div *ngFor="let s of skeleton" class="chat-thread__sk" [class.chat-thread__sk--out]="s.out" aria-hidden="true">
          <span *ngIf="!s.out" class="chat-sk chat-sk--avatar"></span>
          <span class="chat-sk chat-sk--bubble" [style.width.px]="s.w"></span>
        </div>
      </div>

      <ng-container *ngFor="let item of items; trackBy: trackByKey">
        <chat-day-separator *ngIf="item.type === 'day'" class="chat-thread__sep" [label]="item.label || ''"></chat-day-separator>
        <chat-day-separator *ngIf="item.type === 'unread'" class="chat-thread__sep" variant="unread" data-unread
          [label]="item.label || ''"></chat-day-separator>
        <chat-message *ngIf="item.type === 'message' && item.message" class="chat-thread__msg" [attr.data-key]="item.key"
          [class.chat-thread__msg--grouped]="!item.groupStart" [class.chat-thread__msg--hit]="!!item.hit"
          [class.chat-thread__msg--focus]="!!focusKey && item.key === focusKey" [message]="item.message" [mine]="!!item.mine"
          [showAuthor]="!!item.showAuthor" [groupStart]="!!item.groupStart" [groupEnd]="!!item.groupEnd"
          [showAvatar]="true" [avatarSrc]="item.avatarSrc" [avatarName]="item.avatarName" [avatarTip]="item.avatarTip" [strings]="strings"
          [canManageVisits]="canManageVisits" [canQualify]="canQualify" [actionBusy]="actionBusy" [editWindowSeconds]="editWindowSeconds"
          [deleteWindowSeconds]="deleteWindowSeconds" (editMessage)="editMessage.emit($event)"
          [canReply]="canReply" [meId]="meId" (reply)="reply.emit($event)" (jumpTo)="jumpTo.emit($event)" (react)="react.emit($event)"
          (retry)="retry.emit($event)" (deleteMessage)="deleteMessage.emit($event)"
          (deleteFile)="deleteFile.emit($event)" (openImage)="openImage.emit($event)" (visitAction)="visitAction.emit($event)" (cardAction)="cardAction.emit($event)" [dealId]="dealId"></chat-message>
      </ng-container>

      <!-- "a escrever…" do outro lado -->
      <div *ngIf="typing" class="chat-thread__typing" aria-hidden="true">
        <chat-avatar [src]="otherPhoto" [name]="otherName" [size]="32"></chat-avatar>
        <span class="chat-thread__typing-bubble"><i></i><i></i><i></i></span>
      </div>
    </div>
  </ngx-simplebar>

  <!-- "↓ novas mensagens" quando se está a ler acima -->
  <button *ngIf="!atBottom && items.length > 0" type="button" class="chat-thread__jump" [class.chat-thread__jump--count]="unseen > 0"
    [attr.aria-label]="newMessagesLabel" (click)="jumpToLatest()">
    <chat-icon name="arrowdown" [size]="15"></chat-icon>
    <span *ngIf="unseen > 0">{{ newMessagesLabel }}</span>
  </button>
</div>
